import JobsIntroduction from './jobs-introduction';

export default class JobsIntroductionDesktop extends JobsIntroduction {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/jobs-introduction/jobs-introduction.desktop.js